module.exports = __webpack_public_path__ + "static/img/zn-product.4e67fab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zn-product.png
// module id = PpyB
// module chunks = 0